import React, { useEffect, useState } from 'react';

import { toLocale, toCurrency, toPercent } from '../../helpers/numberHelper';
import { getPropsFromFigures } from './utils';

import VarianceCardItem from '../common/varianceCardItem';

import './totalsCard.style.css';

const totalsCard = (props) => {
    const { currency, showForecast } = props;
    const [revProps, setRevProps] = useState({});

    useEffect(() => {
        setRevProps(getPropsFromFigures(props));
        return () => {
            setRevProps({});
        };
    }, [props]);

    const vsLySpit = revProps.revenue - revProps.lySpitRevenue;
    const isForecastNull = revProps.forecast === null || !showForecast;
    const vsForecast = isForecastNull ? 0 : revProps.revenue - revProps.forecast;
    const isBudgetNull = revProps.budget === null;
    const vsBudget = isBudgetNull ? 0 : revProps.revenue - revProps.budget;
    return (
        <div className="TotalsCard">
            <div className="TotalsCardItem">
                <div className="TotalsCardItemValue">{toLocale(revProps.rooms)}</div>
                <div className="TotalsCardItemLabel">Rooms Sold</div>
            </div>
            <div className="TotalsCardItem">
                <div className="TotalsCardItemValue">{toCurrency(revProps.revenue / 100, currency)}</div>
                <div className="TotalsCardItemLabel">Revenue</div>
            </div>
            <div className="TotalsCardItemSeparator"></div>
            <div className="TotalsCardItem">
                <div className="TotalsCardItemValue">{toCurrency(revProps.adr / 100, currency, 2)}</div>
                <div className="TotalsCardItemLabel">ADR</div>
            </div>
            <div className="TotalsCardItem">
                <div className="TotalsCardItemValue">{toCurrency(revProps.revPar / 100, currency, 2)}</div>
                <div className="TotalsCardItemLabel">RevPAR</div>
            </div>
            <div className="TotalsCardItem">
                <div className="TotalsCardItemValue">{toPercent(revProps.occupancy)}</div>
                <div className="TotalsCardItemLabel">Occupancy</div>
            </div>
            <div className="TotalsCardItemSeparator"></div>
            <div className="TotalsCardItem">
                <VarianceCardItem
                    text="vs Forecast"
                    signedAmount={vsForecast}
                    displayAmount={isForecastNull ? 'N/A' : toCurrency(vsForecast / 100, currency)}
                />
            </div>
            <div className="TotalsCardItem">
                <VarianceCardItem
                    text="vs Budget"
                    signedAmount={vsBudget}
                    displayAmount={isBudgetNull ? 'N/A' : toCurrency(vsBudget / 100, currency)}
                />
            </div>
            <div className="TotalsCardItem">
                <VarianceCardItem
                    text="vs LY SPIT"
                    signedAmount={vsLySpit}
                    displayAmount={toCurrency(vsLySpit / 100, currency)}
                />
            </div>
        </div>
    );
};

export default totalsCard;
